// frontend/src/pages/dashboard/accounts/InstagramModals.js
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * InstagramModals holds everything for:
 *  - Connect Instagram Modal (pending IG accounts)
 *  - Delete/Edit Instagram Modal (connected IG accounts)
 *  - Confirm Deletion
 *
 * Props you'll pass in from Accounts.js:
 *
 *   showIgModal, setShowIgModal,
 *   igAccounts, selectedIgIds,
 *   handleIgCheckboxChange, handleConnectSelectedIg,
 *
 *   showIgDeleteModal, setShowIgDeleteModal,
 *   showIgDeleteConfirmModal, setShowIgDeleteConfirmModal,
 *   handleDeleteIgAccounts, handleDeleteIgConfirm,
 *
 *   accounts  // if you need to look up the current IG accounts from the state
 */
export default function InstagramModals({
  showIgModal,
  setShowIgModal,
  igAccounts,
  selectedIgIds,
  handleIgCheckboxChange,
  handleConnectSelectedIg,

  showIgDeleteModal,
  setShowIgDeleteModal,
  showIgDeleteConfirmModal,
  setShowIgDeleteConfirmModal,
  handleDeleteIgAccounts,
  handleDeleteIgConfirm,

  accounts,
}) {
  // For referencing any existing IG data from "accounts"
  const igAcc = accounts
    ? accounts.find((acc) => acc.platform.toLowerCase() === 'instagram')
    : null;

  return (
    <>
      {/* ********** CONNECT INSTAGRAM MODAL (Pending IG Accounts) ********** */}
      <Modal
  show={showIgModal}
  onHide={() => setShowIgModal(false)}   // ← ONE new prop
  centered
>
        <Modal.Header closeButton>
          <Modal.Title>Select Instagram Accounts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {igAccounts && igAccounts.length === 0 ? (
            <p>No Instagram accounts found.</p>
          ) : (
            <ul className="list-group">
              {igAccounts.map((acc) => {
                const checked = selectedIgIds.includes(acc.igId);
                return (
                  <li key={acc.igId} className="list-group-item d-flex align-items-center">
                    {/* Checkbox for selecting which IG accounts to connect */}
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={checked}
                      onChange={() => handleIgCheckboxChange(acc.igId)}
                    />
                    {/* Avatar */}
                    {acc.igProfilePic && (
                      <img
                        src={acc.igProfilePic}
                        alt={acc.igUsername || 'IG Avatar'}
                        style={{
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          marginRight: '8px',
                        }}
                      />
                    )}
                    {/* Username */}
                    <span>{acc.igUsername}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowIgModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConnectSelectedIg}>
            Connect
          </Button>
        </Modal.Footer>
      </Modal>

     {/* ********** EDIT/DELETE INSTAGRAM MODAL (Connected IG Accounts) ********** */}
<Modal show={showIgDeleteModal} onHide={() => setShowIgDeleteModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Delete Instagram Accounts</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {(!igAcc || !igAcc.connectedPages || igAcc.connectedPages.length === 0) ? (
      <p>No connected Instagram accounts to delete.</p>
    ) : (
      <ul className="list-group">
        {igAcc.connectedPages.map((item) => {
          const checked = selectedIgIds.includes(item.igId);
          return (
            <li key={item.igId} className="list-group-item d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input me-2"
                checked={checked}
                onChange={() => handleIgCheckboxChange(item.igId)}
              />
              {item.igProfilePic && (
                <img
                  src={item.igProfilePic}
                  alt={item.igUsername || 'IG Avatar'}
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%',
                    marginRight: '8px',
                  }}
                />
              )}
              {/* Use item.igUsername instead of item.username */}
              <span>{item.igUsername}</span>
            </li>
          );
        })}
      </ul>
    )}
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowIgDeleteModal(false)}>
      Cancel
    </Button>
    <Button variant="danger" onClick={handleDeleteIgAccounts}>
      Delete
    </Button>
  </Modal.Footer>
</Modal>

      {/* ********** CONFIRM DELETE INSTAGRAM MODAL ********** */}
      <Modal
        show={showIgDeleteConfirmModal}
        onHide={() => setShowIgDeleteConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete these Instagram accounts?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowIgDeleteConfirmModal(false)}>
            No
          </Button>
          <Button variant="danger" onClick={handleDeleteIgConfirm}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
